import { Download, Trash2 } from 'react-feather';
import { ChangeEvent } from 'react';
import { allowedVideoTypes } from '@/utils/mediaUtils';
import { useTranslation } from 'react-i18next';
import { MediaItem } from '../media-item';
import styles from './FileUploader.module.css';

interface FileUploaderProps {
  files: File[];
  sizeSm?: boolean;
  accept?: string;
  onFilesChange: (files: File[]) => void;
}

export function FileUploader({
  files,
  onFilesChange,
  accept = `image/*, ${allowedVideoTypes.join(', ')}`,
  sizeSm
}: FileUploaderProps) {
  const { t } = useTranslation();

  async function handleFileSelect(event: ChangeEvent<HTMLInputElement>) {
    if (!event.target.files) return;
    const selectedFiles = Array.from(event.target.files);

    onFilesChange([...files, ...selectedFiles]);

    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  function handleFileRemove(name: string) {
    onFilesChange(files.filter((f) => f.name !== name));
  }

  const removeButton = (file: File) => (
    <span className={styles.removeBtn} onClick={() => handleFileRemove(file.name)}>
      <Trash2 color="red" size={20} />
    </span>
  );

  return (
    <div className={styles.wrap}>
      {!!files.length && (
        <div className={styles.filesWrap}>
          {files.map((file) => (
            <MediaItem
              key={file.name}
              sizeSm={sizeSm}
              file={file}
              opacity
              bottomIcon={() => removeButton(file)}
            />
          ))}
        </div>
      )}
      <label className={`${styles.fileLabel} ${sizeSm ? styles.sm : ''}`}>
        <span className={styles.icon}>
          <Download />
        </span>
        <span className={styles.label}>
          {sizeSm ? t('draftUpload.submit') : t('draft.uploadFile')}
        </span>
        <input accept={accept} multiple type="file" onChange={handleFileSelect} />
      </label>
    </div>
  );
}
